export default {"src":"/_next/static/media/mobile-logout.77e471ec.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};